export default "__VITE_ASSET__a4e3f0c4__"